import httpClient from "@/services/base.service.js";

export default {
  getConfigs: function () {
    return httpClient.get("/api/v1/client/config/");
  }
};
